import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Rest } from '../../../../../../rest/rest_client';
import { NotificationsService } from '../../../../../../services/notifications-service/notifications.service';
import { I18nService } from '../../../../../../services/i18n/i18n.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthenticationService } from '../../../../../../core/services/authentication/authentication.service';
import { EntityFormComponent } from 'app/components/entity-form/entity-form.component';
import { ObservationsService } from '../../../../services/table-management/observations.service';
import { UserTimePipe } from 'app/components/shared/UserTimePipe';


@Component({
  selector: 'app-observations-form',
  templateUrl: './observations-form.component.html',
  styleUrls: ['./observations-form.component.css'],
  providers:[ObservationsService],
  standalone: false,
})
export class ObservationsFormComponent extends EntityFormComponent<Rest.InvObservations> implements OnInit {

  title: string;

  @Input() type: Rest.InvObservationsType;
  @Input() id: number;
  @Output() saveCompleted: EventEmitter<number> = new EventEmitter<number>();
  ids: number[] = [];
  date: Date;
  formManipulation: boolean;

  constructor(
    private observationsService: ObservationsService,
    notificationsService: NotificationsService,
    protected i18n: I18nService,
    protected authenticationService: AuthenticationService,
    public translateService: TranslateService,
    private userTime: UserTimePipe
  ) {
    super(observationsService, notificationsService, i18n, authenticationService);
  }

  /**
   * Loads and evaluates all the necessary data before showing the form.
   *
   * @memberof AccessoryFormComponent
   */
  beforeShow() {
    this.ids = [];

    if (this.entity.documents && this.entity.documents.length > 0) {
			this.entity.documents.forEach((x) => this.ids.push(x.id));
		} else {
			this.ids = [-1];
		}

    this.setPermissions();
    this.date = this.entity.date ? this.userTime.utcToCalendarDate(this.entity.date) : null;;
    this.entity.type = this.type;

    if (this.isNew) {
      this.title = this.translateService.instant('tableManagement.sinister.createSinisterObservations');
    } else {
      this.title = this.translateService.instant('tableManagement.sinister.updateSinisterObservations');
    }
  }

  beforeSave(): void {
    this.entity.date = this.date != null ? new Date(this.userTime.toUTCISOString(this.date)): null;
    /*if(this.sinister){
      this.entity.sinister = {} as Rest.InvSinister;
      this.entity.sinister.id = this.sinister.id;
    }*/
  }

   setPermissions() {
    const user = this.authenticationService.user;
    const rolesForForm = ['INV_SINISTER_OBSERVATIONS_CREATE', 'INV_SINISTER_OBSERVATIONS_UPDATE'];

    this.formManipulation = this.authenticationService.isOneRoleGranted(rolesForForm, user);

  }

  createObservation() {
		// console.log("[TAXES-FORM] saveChanges ***");
		// console.log(this.entity);

		this.beforeSave();


		this.observationsService.create(this.entity, {id: this.id}).then((p) => {
			this.entity= p;
			this.isNew = false;
      this.saveCompleted.next(p.id);
		});
			
		
	}

  

}

